import { setCookie, getCookie, currentPageName, bannerSuppressedPages } from '../functions/utils';

export default class TransferBanner {
    constructor(element) {
        this.passedElement = element;
        this.searchQuery = "";
        this.currentPage = currentPageName();
        this.suppressBannerPages = [...bannerSuppressedPages(), "transfers", "transfer-concierge"];
        this.init();
    }

    init = () => {
        if (!this.initialised) {
            this.initialised = true;
            this.getElements();
            this.addEventListeners();
        }
    }

    getElements = () => {
        this.close = this.passedElement.querySelector('#closeTransferBanner');
        const dismissedTransferBanner = getCookie("dismissedTransferBanner");

        if ( !dismissedTransferBanner  && !this.suppressBannerPages.includes(this.currentPage) ) {
            document.body.classList.add("banner--open");
            this.passedElement.classList.remove("banner-closed");
        }
    }

    addEventListeners = () => {
        this.close.addEventListener('click', () => {
            document.body.classList.remove("banner--open");
            this.passedElement.classList.add("banner-closed");
            setCookie("dismissedTransferBanner", true, 90);
        });
    }

}